export default __webpack_public_path__ + "80f7df3ad496ab8af71a287d6acdf3d5.png";